module.exports = __webpack_public_path__ + "static/media/Message_Chat_Box@3x.b2f31ad4.png";